// extracted by mini-css-extract-plugin
export default {"container":"BaseCurrentJobsScreen_container__leH0H","header":"BaseCurrentJobsScreen_header__9kD--","progress":"BaseCurrentJobsScreen_progress__zBhYR"};